import { type ButtonHTMLAttributes, forwardRef } from 'react';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'default' | 'primary' | 'danger' | 'ghost';
  loading?: boolean;
}

/** Kit button (.ui-btn). `loading` shows the spinner and blocks clicks. */
export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { variant = 'default', loading = false, className, type = 'button', disabled, children, ...rest },
  ref,
) {
  const cls = ['ui-btn', variant !== 'default' && variant, loading && 'is-loading', className].filter(Boolean).join(' ');
  return (
    <button ref={ref} type={type} className={cls} disabled={disabled || loading} aria-busy={loading || undefined} {...rest}>
      {children}
    </button>
  );
});
